<p-toast position="top-right"></p-toast>
<div class="h-full min-h-0 overflow-hidden bg-gray-25 dark:bg-[var(--color-bunker-400)]">
  <router-outlet></router-outlet>
</div>